import Immutable from 'immutable';
import React from 'react';

import BoxLayout from 'sharedreact/components/BoxLayout';
import Button from 'sharedreact/components/Button';
import ModalBackground from 'sharedreact/components/ModalBackground';
import SlideOut from 'sharedreact/components/SlideOut';
import WebAppLink from 'sharedreact/components/WebAppLink';
import WebApp from 'sharedreact/data/WebApp';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  apps: Immutable.List<WebApp>,
  allAppsUrl?: string,
  language: string,
  show: boolean,
  currentWorkspace: string,
  
  onClose: () => void
};

class AppLauncherSlideOut extends React.Component<Props> {
  override render (): React.ReactNode {
    const { apps, allAppsUrl, language, show, currentWorkspace, onClose } = this.props;

    return (
      <ModalBackground
        visible={show}
        className='esko_applauncher-slideout-background'
        onClick={onClose}>
        <SlideOut id='ae_slideout_applauncher'
          language={language}
          visible={show}
          className='esko_applauncher-slideout'
          onClose={onClose}
          noPanel>
          <div className='esko_slideoutcontent'>
            <div className='esko_applauncher-text'>{translate('shared.applauncher.text')}</div>
            {apps.map((app) => {
              const active: boolean = app.name === currentWorkspace;
              return <WebAppLink key={app.id} webApp={app} active={active} small />;
            })}
            <div className='esko_applauncher-text'>
              <hr className='esko_applauncher-separator' />
            </div>
            {allAppsUrl
            ? <div className='esko_applauncher-applink esko_applauncher-applink-small'>
              <a href={ConnectionSupport.createWebAppUrl(allAppsUrl)}>
                <BoxLayout horizontal>
                  <div className='esko_applauncher-checkmark'>
                    {currentWorkspace === 'Home'
                    ? <span className='bi bi-check esko_applauncher-checkmark-color' />
                    : null
                    }
                  </div>
                  <div>
                    <span>{translate('shared.applauncher.allapps')}</span>
                  </div>
                </BoxLayout>
              </a>
            </div>
            : null
            }
          </div>
          <BoxLayout className='esko_slideoutfooter esko_applauncher-footer' horizontal>
            <Button id='ae_slideout_applauncher_close' onClick={onClose}>{translate('shared.general.close')}</Button>
          </BoxLayout>
        </SlideOut>
      </ModalBackground>
    );
  }
}

export default AppLauncherSlideOut;
